export default __webpack_public_path__ + "assets/img/login-background.93d834f21479f692e1520ec451bdff01.svg";